import React from 'react';
import { Radio } from 'zarm';

import componentConfig from './componentConfig';
import { IRadioItemProps } from './type';
// import { deepCopy, getFormId, isObject } from "../../utils/tools";

// const getName = (item: IRadioItem) => {
//   return item.dataBind || item.name;
// };

const RadioItem = (props: IRadioItemProps) => {
  const { _crengine, label, childrens, checkedValue, value: fvalue, onChange } = props;
  const { form } = _crengine || {};
  // console.log(props, 'pppppp------')

  // // 子组件change事件
  // const onChildChange = (item: IRadioItem) => {
  //   const { value: subValue, name: subName, dataBind: subDataBind } = item;
  //   console.log(item, "item");
  //   const tempname = subName || subDataBind;
  //   const copyValue = deepCopy(checkedValue);

  //   // select-async 异步组件时 subValue 返回是对象
  //   let formatValue = "";
  //   if (isObject(subValue) && subValue.value) {
  //     formatValue = subValue.value;
  //   } else {
  //     formatValue = subValue;
  //   }

  //   const childValue = { name: tempname, value: formatValue };

  //   if (Array.isArray(copyValue.childrens)) {
  //     if (copyValue.childrens.find(itemV => itemV.name === subName)) {
  //       copyValue.childrens.forEach(itemV => {
  //         if (itemV.name === subName) {
  //           itemV.value = formatValue;
  //         }
  //       });
  //     } else {
  //       copyValue.childrens.push(childValue);
  //     }
  //   }

  //   // 设置form value
  //   if (form) {
  //     const names = getFormId(subDataBind, path);
  //     form.setFieldsValue({
  //       [names]: formatValue
  //     });
  //   }

  //   onChange && onChange(copyValue);
  // };

  // 第一级单选框change 同时获取子组件的默认值
  const onRadioChange = (e) => {
    const targetValue = e.target.value;
    onChange && onChange(targetValue);
  };

  const renderChild = () => {
    if (!(childrens && Array.isArray(childrens) && childrens.length)) {
      return;
    }

    return childrens.map((item, index) => {
      const { widget, defaultValue: childDefaultValue } = item;

      const Components = componentConfig[widget] ? componentConfig[widget] : null;

      if (item.wprops) {
        item = Object.assign(item, item.wprops);
        delete item.wprops;
      }

      if (Components) {
        return (
          <Components
            key={index}
            {...item}
            form={form}
            _crengine={{ ..._crengine, ...item }}
            defaultValue={childDefaultValue}
          />
        );
      }
      return null;
    });
  };

  // const checked = String(checkedValue.value) === String(fvalue);
  const checked = String(checkedValue) === String(fvalue);

  return (
    <div className="radio-child-item">
      <Radio className='radio-select' checked={checked} value={fvalue} onChange={onRadioChange}>
        {label}
      </Radio>
      {checked && renderChild()}
    </div>
  );
};

export default RadioItem;
